import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-db8aeeae")

_pushScopeId("data-v-db8aeeae")
const _hoisted_1 = { class: "register-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "top" }, "账号注册", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("获取验证码")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("返回登录")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_button = _resolveComponent("el-button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_form, {
      model: _ctx.information,
      rules: _ctx.rules,
      "label-position": "left",
      "label-width": "80px",
      ref: "registerForm"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "姓名",
              prop: "username"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.information.username,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.information.username = $event)),
                  type: "text",
                  name: "username",
                  required: "required"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_3,
            _createVNode(_component_el_form_item, {
              label: "身份证号",
              prop: "ID"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.information.ID,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.information.ID = $event)),
                  type: "text",
                  name: "ID",
                  required: "required"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "手机号",
              prop: "phoneNumber"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.information.phoneNumber,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.information.phoneNumber = $event)),
                  type: "text",
                  name: "phoneNumber",
                  required: "required"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_4,
            _createVNode(_component_el_form_item, {
              label: "验证码",
              prop: "verificationCode"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.information.verificationCode,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.information.verificationCode = $event)),
                  type: "text",
                  name: "verificationCode",
                  required: "required"
                }, {
                  append: _withId(() => [
                    _createVNode(_component_el_button, { onClick: _ctx.getCode }, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, null, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "密码",
              prop: "password1"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.information.password1,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.information.password1 = $event)),
                  type: "password",
                  name: "password1",
                  required: "required"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_6,
            _createVNode(_component_el_form_item, {
              label: "确认密码",
              prop: "password2"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.information.password2,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.information.password2 = $event)),
                  type: "password",
                  name: "password2",
                  required: "required"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_7, [
          _createVNode("input", {
            type: "button",
            value: "立即注册",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
          }),
          _hoisted_8,
          _createVNode(_component_router_link, { to: "login" }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
})